import formRequest from '@/utils/formRequest'
import request from '@/utils/request-axios'
import api from '@/utils/api'

//登陆
export function loginForm(params) {
  return formRequest(`${api.loginForm}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

export function reLogin(params) {
  return formRequest(`${api.reLogin}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//路由菜单
export function getMenuTree() {
  return request(`${api.getMenuTree}`, {
    loading: true,
    method: 'get',
  });
}

//获取登录验证码
export function getLoginCode(params) {
  return formRequest(`${api.getLoginCode}${params}`, {
    loading: true,
    method: 'get',
  });
}

//todo 微信登录二维码
export function getQrCode() {
  return request(`${api.getQrCode}`, {
    loading: true,
    method: 'get',
  });
}

//todo 微信二维码状态
export function getQrStatus(id) {
  return request(`${api.getQrStatus}?identitySid=${id}`, {
    loading: true,
    method: 'get',
  });
}


//退出登陆
export function logout() {
  return request(`${api.logout}`, {
    loading: true,
    method: 'delete',
  });
}

export function logoutAuto() {
  return request(`${api.logoutAuto}`, {
    loading: true,
    method: 'delete',
  });
}


//用户认证
//选择身份并且进入
export function checkIdentity(params) {
  return request(`${api.checkIdentity}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

export function refreshToken(params) {
  return formRequest(`${api.refreshToken}`, {
    loading: true,
    method: 'post',
    data: params
  });
}


//个人中心
export function rePhone(params) {
  return request(`${api.rePhone}`, {
    loading: true,
    method: 'put',
    data: params
  });
}

export function rePwd(params) {
  return request(`${api.rePwd}`, {
    loading: true,
    method: 'put',
    data: params
  });
}

export function getUserInfo(params) {
  return request(`${api.getUserInfo}`, {
    loading: true,
    method: 'get',
  });
}

export function editUserInfo(params) {
  return request(`${api.editUserInfo}`, {
    loading: true,
    method: 'put',
    data: params
  });
}

//总揽：获取我的消息
export function getMyMessage(params) {
  return request(`${api.getMyMessage}`, {
    loading: true,
    method: 'get',
  });
}

//查看更多申请信息：获取申请人消息
export function getApplyMessage(params) {
  return request(`${api.getApplyMessage}`, {
    loading: true,
    method: 'get',
  });
}

//获取更多到期提醒 ：获取合同消息
export function getContractMessage(params) {
  return request(`${api.getContractMessage}`, {
    loading: true,
    method: 'get',
  });
}

//获取更多审批消息：获取审批消息
export function getProcessMessage(params) {
  return request(`${api.getProcessMessage}`, {
    loading: true,
    method: 'get',
  });
}




// WEBPACK FOOTER //
// ./src/services/login.js